import React, {PureComponent} from 'react'

import {Translate, withLocalize} from "react-localize-redux";
import {connect} from "react-redux";

import italianNotFoundTranslations from "../../translations/notFound/it.notFound.json";
import englishNotFoundTranslations from "../../translations/notFound/en.notFound.json";

class NotFound extends PureComponent {
    constructor(props) {
        super(props);

        this.props.addTranslationForLanguage(italianNotFoundTranslations, "it");
        this.props.addTranslationForLanguage(englishNotFoundTranslations, "en");
    }

    render() {
        return (
       <>
           <h3 className="mb-0">
                <Translate id="notFound.title" />
           </h3>
           <Translate id="notFound.body" />
       </>
     );
   }
}
const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {

    }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(NotFound));